import { render, staticRenderFns } from "./IndexCreation.vue?vue&type=template&id=5da8df30&"
import script from "./IndexCreation.vue?vue&type=script&lang=js&"
export * from "./IndexCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports